// biome-ignore lint/style/noRestrictedImports:  this is the source of truth
import { createTheme, ThemeOptions, ThemeProvider as BpDesignThemeProvider, useTheme } from '@mui/material/styles';
import THEME_ID from '@mui/material/styles/identifier';
import CssBaseline from '@mui/material/CssBaseline';
import { deepmerge } from '@mui/utils';
import { BaseTheme, baseTheme } from './impl/baseTheme';
import * as tokens from '@utmost.co/utmost-design-tokens';

export interface BpDesignSystemThemeOptions extends Partial<BaseTheme> {
  status?: {
    danger?: string;
    warning?: string;
  };
}

export interface BpDesignSystemTheme extends BaseTheme {
  status: {
    danger: string;
    warning: string;
  };
}

declare module '@mui/material/styles' {
  // @ts-ignore
  interface Theme extends BpDesignSystemTheme {}
  // @ts-ignore
  interface ThemeOptions extends BpDesignSystemThemeOptions {}

  interface Palette {
    default: Palette['primary'];
  }

  interface PaletteOptions {
    default?: PaletteOptions['primary'];
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    default: true;
  }
}

function createBpDesignTheme(options?: ThemeOptions) {
  return createTheme(deepmerge(baseTheme, options));
}

const useBpDesignTheme = useTheme;

export {
  BpDesignThemeProvider,
  createBpDesignTheme,
  useBpDesignTheme,
  CssBaseline,
  THEME_ID,
  baseTheme as bpDesignBaseTheme,
  tokens
};
